import React, { useState } from "react";
import { Button, Input } from "antd";
import message from "@/utils/globalMessage";
import { api } from "@redux/api";

const toDateString = (value) => {
    if (!value) return "";
    if (typeof value === "string") return value.slice(0, 10);
    if (typeof value.format === "function") return value.format("YYYY-MM-DD");
    return "";
};

const errorText = (error) => {
    const data = error?.response?.data;
    if (typeof data?.error === "string") return data.error;
    if (typeof data?.detail === "string") return data.detail;
    if (typeof data?.message === "string") return data.message;
    return "Failed to fetch average outdoor temperature.";
};

const ServiceDateTemperature = ({
    value,
    onChange,
    id,
    disabled,
    formRef,
    record,
    service_start_date,
    end_start_date,
}) => {
    const [loading, setLoading] = useState(false);
    const shown = value !== undefined ? value : (record ?? "");

    const fillFromWeather = async () => {
        const start = toDateString(
            formRef?.getFieldValue?.("service_start_date") || service_start_date
        );
        const end = toDateString(
            formRef?.getFieldValue?.("end_start_date") || end_start_date
        );
        if (!start || !end) {
            message.warning("Select the service start and end dates first.");
            return;
        }
        setLoading(true);
        try {
            const response = await api.getAvgOat(start, end);
            const data = response?.data;
            if (data?.avgoat === undefined || data?.avgoat === null) {
                message.error("Failed to fetch average outdoor temperature.");
                return;
            }
            if (onChange) {
                onChange(data.avgoat);
            } else if (formRef?.setFieldsValue) {
                formRef.setFieldsValue({ avgoat: data.avgoat });
            }
            const missingNote = data.missing_day_count
                ? ` ${data.missing_day_count} day(s) had no reading and were left out of the average.`
                : "";
            const previous = shown === "" || shown === undefined || shown === null
                ? null
                : Number(shown);
            if (
                previous !== null
                && Number.isFinite(previous)
                && Math.abs(previous - Number(data.avgoat)) >= 0.05
            ) {
                const delta = (Number(data.avgoat) - previous).toFixed(1);
                const signed = delta.startsWith("-") ? delta : `+${delta}`;
                message.info(
                    `Weather average is ${data.avgoat}°F across ${data.day_count} days. Current value is ${previous}°F (${signed}).${missingNote}`
                );
            } else {
                message.success(
                    `Filled ${data.avgoat}°F from ${data.day_count} daily mean temperatures.${missingNote}`
                );
            }
        } catch (error) {
            message.error(errorText(error));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex" style={{ width: "100%" }}>
            <Input
                id={id}
                type="number"
                style={{ flex: 1 }}
                value={shown ?? ""}
                disabled={disabled}
                onChange={(event) => onChange?.(event.target.value)}
            />
            <Button
                type="primary"
                htmlType="button"
                className="ml-5"
                disabled={disabled}
                loading={loading}
                onClick={fillFromWeather}
                icon={<i className="fa-solid fa-temperature-high pr-4"></i>}
            >
                Auto Fill
            </Button>
        </div>
    );
};

export default ServiceDateTemperature;
